import PropTypes from 'prop-types';

import { Announcement, LightBulbIcon, RateIcon } from '@utilities';
import { submitReportFeedback } from '@api/reports';

import FeedbackFooter from '../../../../components/FeedbackFooter';

import RecommendationFooter from './components/RecommendationFooter';

import { negativeFeedbackOptions, positiveFeedbackOptions } from './utilities/helpers';

import styles from './_index.module.scss';

const WhatsNextTab = ({ hideHelpCenter, whatsNextData }) => {
  return (
    <div>
      {whatsNextData?.feedback?.recommendedReportId && (
        <Announcement
          footer={
            <FeedbackFooter
              feedbackId={whatsNextData?.feedback?.recommendedReportId}
              feedbackLabel={
                <>
                  <LightBulbIcon />
                  What&apos;s Next?<sup>BETA</sup>&nbsp;. Was this helpful?
                </>
              }
              initialFeedback={whatsNextData?.feedback}
              negativeFeedbackOptions={negativeFeedbackOptions}
              onSubmit={submitReportFeedback}
              positiveFeedbackOptions={positiveFeedbackOptions}
            />
          }
          header={`Was this ${whatsNextData?.feedback?.recommendedReportName} recommendation helpful?`}
          icon={<RateIcon />}
          text="Your feedback matters to us! Tell us what you think so we can continue delivering suggestions that suit your needs and expectations."
          variant="feedback"
        />
      )}
      {whatsNextData?.recommendation?.description && (
        <Announcement
          footer={
            <RecommendationFooter
              hideHelpCenter={hideHelpCenter}
              recommendation={whatsNextData?.recommendation}
            />
          }
          header="Looking to cast an even wider net?"
          icon={<LightBulbIcon />}
          text={
            <div
              className={styles['whats-next-tab-text']}
              dangerouslySetInnerHTML={{ __html: whatsNextData?.recommendation?.description }}
            />
          }
          variant="recommendation"
        />
      )}
    </div>
  );
};

WhatsNextTab.propTypes = {
  hideHelpCenter: PropTypes.bool,
  whatsNextData: PropTypes.shape({
    feedback: PropTypes.object,
    recommendation: PropTypes.object,
  }),
};

export default WhatsNextTab;
